import React, { useState } from 'react';
import { testDocumentGeneration } from '../utils/testDocumentGeneration';

const TestDocumentGeneration = () => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    userFirstName: 'Prénom',
    userLastName: 'Nom',
    userEmail: 'test@example.com',
    userPhone: '+33612345678',
    userAddress: '123 Rue de Test',
    userCity: 'Ville Test',
    userZipcode: '75000',
    userCountry: 'France',
    hostName: 'Hébergeant Test',
    actTitle: 'PASSEPORT BIOMÉTRIQUE',
    amount: 73,
    generateReceipt: true,
    generateShippingForm: true
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResults(null);

    try {
      const { generateReceipt, generateShippingForm, ...userData } = formData;
      
      const testResults = await testDocumentGeneration({
        generateReceipt,
        generateShippingForm,
        userData
      });
      
      setResults(testResults);
    } catch (err) {
      console.error('Erreur lors du test:', err);
      setError(err.message || 'Une erreur est survenue lors de la génération des documents');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Test de génération de documents</h1>
      <p className="mb-4 text-gray-600">
        Cet outil permet de tester la génération de documents PDF sans enregistrement en base de données.
      </p>
      
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Options de génération</h2>
          <div className="flex flex-wrap -mx-2">
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  name="generateReceipt"
                  checked={formData.generateReceipt}
                  onChange={handleChange}
                  className="mr-2"
                />
                Générer un reçu
              </label>
            </div>
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  name="generateShippingForm"
                  checked={formData.generateShippingForm}
                  onChange={handleChange}
                  className="mr-2"
                />
                Générer un formulaire d&apos;expédition
              </label>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Informations de l&apos;acte</h2>
          <div className="flex flex-wrap -mx-2">
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="actTitle">
                Titre de l&apos;acte
              </label>
              <input
                type="text"
                id="actTitle"
                name="actTitle"
                value={formData.actTitle}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="amount">
                Montant (€)
              </label>
              <input
                type="number"
                id="amount"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Informations personnelles</h2>
          <div className="flex flex-wrap -mx-2">
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userLastName">
                Nom
              </label>
              <input
                type="text"
                id="userLastName"
                name="userLastName"
                value={formData.userLastName}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userFirstName">
                Prénom
              </label>
              <input
                type="text"
                id="userFirstName"
                name="userFirstName"
                value={formData.userFirstName}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userEmail">
                Email
              </label>
              <input
                type="email"
                id="userEmail"
                name="userEmail"
                value={formData.userEmail}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="px-2 mb-4 w-full md:w-1/2">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userPhone">
                Téléphone
              </label>
              <input
                type="text"
                id="userPhone"
                name="userPhone"
                value={formData.userPhone}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Adresse</h2>
          <div className="flex flex-wrap -mx-2">
            <div className="px-2 mb-4 w-full">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userAddress">
                Adresse
              </label>
              <input
                type="text"
                id="userAddress"
                name="userAddress"
                value={formData.userAddress}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="px-2 mb-4 w-full md:w-1/3">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userCity">
                Ville
              </label>
              <input
                type="text"
                id="userCity"
                name="userCity"
                value={formData.userCity}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="px-2 mb-4 w-full md:w-1/3">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userZipcode">
                Code postal
              </label>
              <input
                type="text"
                id="userZipcode"
                name="userZipcode"
                value={formData.userZipcode}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="px-2 mb-4 w-full md:w-1/3">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="userCountry">
                Pays
              </label>
              <input
                type="text"
                id="userCountry"
                name="userCountry"
                value={formData.userCountry}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Informations d&apos;hébergement</h2>
          <div className="flex flex-wrap -mx-2">
            <div className="px-2 mb-4 w-full">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="hostName">
                Nom et prénom de l&apos;hébergeant (si différent)
              </label>
              <input
                type="text"
                id="hostName"
                name="hostName"
                value={formData.hostName}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center">
          <button
            type="submit"
            disabled={loading}
            className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {loading ? 'Génération en cours...' : 'Générer les documents'}
          </button>
        </div>
      </form>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          <p className="font-bold">Erreur</p>
          <p>{error}</p>
        </div>
      )}

      {results && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          <p className="font-bold mb-2">Documents générés avec succès!</p>
          
          {results.receiptUrl && (
            <div className="mb-2">
              <p>Reçu:</p>
              <div className="flex items-center mt-1">
                <a 
                  href={results.receiptUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-3 rounded mr-2"
                >
                  Voir le reçu
                </a>
                <span className="text-sm text-gray-600 break-all">{results.receiptUrl}</span>
              </div>
            </div>
          )}
          
          {results.shippingFormUrl && (
            <div className="mb-2">
              <p>Formulaire d&apos;expédition:</p>
              <div className="flex items-center mt-1">
                <a 
                  href={results.shippingFormUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded mr-2"
                >
                  Voir le formulaire
                </a>
                <span className="text-sm text-gray-600 break-all">{results.shippingFormUrl}</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TestDocumentGeneration;
